import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { DreamDestinationModalComponent } from './dream-destination-modal/dream-destination-modal.component';
import { SharedModule } from '../shared/shared.module';
import { ShareDealModalComponent } from './share-deal-modal/share-deal-modal.component';
import { DividerModule } from 'primeng/divider';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { BookFlightModalComponent } from './book-flight-modal/book-flight-modal.component';
import { SupportModalComponent } from './support-modal/support-modal.component';
import { UpdateModalComponent } from './update-modal/update-modal.component';
import { DeleteModalComponent } from './delete-modal/delete-modal.component';
import { DepartureAirportsModalComponent } from './departure-airports-modal/departure-airports-modal.component';
import { FavoriteAirlineModalComponent } from './favorite-airline-modal/favorite-airline-modal.component';
import { SmsWarningModalComponent } from './sms-warning-modal/sms-warning-modal.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { ListboxModule } from 'primeng/listbox';
import { CheckboxModule } from 'primeng/checkbox';
import { DowngradeModalComponent } from './downgrade-modals/DowngradeModals';
import { GenericModalComponent } from './downgrade-modals/generic-modal';
import { RouterModule } from '@angular/router';
import {WaitlistModalComponent} from './waitlist-modals/waitlist-modal.component';
import {UnlockDealModalComponent} from './unlock-deal-modal/unlock-deal-modal.component';
import { PerksWarningModalComponent } from './perks-warning-modal/perks-warning-modal.component';
import { PriceTrackingModalComponent } from './price-tracking-modal/price-tracking-modal.component';
import { EasterEggModalComponent } from './easter-egg-modal/easter-egg-modal.component';
import { ExpiredDealsModalComponent } from './expired-deals-modal/expired-deals-modal.component';
import { DealExpiredModalComponent } from './deal-expired-modal/deal-expired-modal.component';
import {CarouselsModule} from '../carousels/carousels.module';
import {TopbarNavModalComponent} from './topbar-nav-modal/topbar-nav-modal.component';
import {TopbarNavLinksComponent} from './topbar-nav-modal/topbar-nav-links.component';

@NgModule({
  declarations: [
    DreamDestinationModalComponent,
    ShareDealModalComponent,
    BookFlightModalComponent,
    SupportModalComponent,
    UpdateModalComponent,
    DeleteModalComponent,
    DepartureAirportsModalComponent,
    FavoriteAirlineModalComponent,
    SmsWarningModalComponent,
      DowngradeModalComponent,
      GenericModalComponent,
      WaitlistModalComponent,
      UnlockDealModalComponent,
      PerksWarningModalComponent,
      PriceTrackingModalComponent,
      EasterEggModalComponent,
      ExpiredDealsModalComponent,
      DealExpiredModalComponent,
      TopbarNavModalComponent,
      TopbarNavLinksComponent,

  ],
    imports: [
        CommonModule,
        RouterModule,
        TagModule,
        BadgeModule,
        ButtonModule,
        DialogModule,
        ReactiveFormsModule,
        IconFieldModule,
        InputIconModule,
        InputTextModule,
        SharedModule,
        DividerModule,
        DynamicDialogModule,
        MultiSelectModule,
        FormsModule,
        ListboxModule,
        CheckboxModule,
        CarouselsModule,
    ],
    exports: [
        DreamDestinationModalComponent,
        ShareDealModalComponent,
        BookFlightModalComponent,
        SupportModalComponent,
        UpdateModalComponent,
        DeleteModalComponent,
        DepartureAirportsModalComponent,
        FavoriteAirlineModalComponent,
        SmsWarningModalComponent,
        DowngradeModalComponent,
        GenericModalComponent,
        PerksWarningModalComponent,
        WaitlistModalComponent,
        UnlockDealModalComponent,
        PriceTrackingModalComponent,
        EasterEggModalComponent,
        ExpiredDealsModalComponent,
        DealExpiredModalComponent,
        TopbarNavLinksComponent,
    ],
})
export class ModalsModule {}
